import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    label: {
        display: 'block',
        marginBottom: 4
    },
    paymentCallbackFrame: {
        display: 'block',
        width: '100%',
        height: '500px',
        background: 'transparent',
        overflow: 'hidden',
        border: 0,
        margin: 0,
        padding: 0,
        position: 'static'
    },
    inputFrame: {
        height: 60
    }
}));

export default useStyles;

